import { TFunction } from "i18next";
import React, { ReactElement } from "react";
import { ISubscriptionsReportData, SubscriptionsReportFactory } from "../interfaces/factories";
import { SubscriptionReportTable } from "../screens/components";

export class SubscriptionsReportFactoryImpl implements SubscriptionsReportFactory {
    create(data: ISubscriptionsReportData, translate: TFunction<"reports", undefined>): ReactElement {
        if (data.success && typeof data.response !== 'string') {
            if (data.response.length > 0) return <SubscriptionReportTable response={data.response} translate={translate} />;
        }
        if (typeof data.response === 'string') return <p>{translate(data.response)}</p>
        return <p>{translate('no_data')}</p>
    }
}